import React from 'react'
import { PopoverBody, UncontrolledPopover } from 'reactstrap'
import { ButtonWhite } from '../Buttons/ButtonWhite'
import { CustomPopoverOption } from './CustomPopoverOption'
import './customPopover.css'

export const CustomPopoverWhite = ({ idPopover, trigger = "legacy", buttonIcon, children, placementTooltip, textTooltip, withTooltip = false, options = [], buttonClassName = '', popoverPlacement = "top", disabled, }) => {

    return (
        <>
            <ButtonWhite
                placementTooltip={placementTooltip}
                textTooltip={textTooltip}
                idTargetTooltip={idPopover}
                withTooltip={withTooltip}
                className={buttonClassName}
                disabled={disabled}
            >
                {buttonIcon}
            </ButtonWhite>
            <UncontrolledPopover
                disabled={disabled}
                placement={popoverPlacement}
                target={idPopover}
                trigger={trigger}
            >
                <PopoverBody className='popover-white custom-popover-body'>
                    {options.map((option, idx) =>
                        <CustomPopoverOption
                            option={option}
                            key={idx}
                        />
                    )}
                    {children}
                </PopoverBody>
            </UncontrolledPopover >
        </>
    )
}
